import { EntriesService } from '@elc/common';

const entryService = new EntriesService();

export const increaseEntriesCounter = entryService.newEntry;
